// Phase 1 report catalog (CPRN00117-867).
// Categories, reports and filter keys. All data is real: devices, shifts,
// parts and reasons come from GraphQL; counts come from Timestream datapoints.
// Inventory & Consumption and Workforce & Shift are intentionally excluded.

export const CATEGORIES = [
    {
        key: "production",
        label: "Production Performance",
        color: "#2f6fed",
        reports: [
            {
                id: "1.1",
                name: "Daily Production Report",
                template: "productionKpi",
                filters: ["date", "devices", "part"],
                desc: "Daily output snapshot with KPI cards and machine-level actual vs target.",
            },
            {
                id: "1.2",
                name: "Shift Production Report",
                template: "shiftKpi",
                filters: ["date", "shift", "devices", "part"],
                desc: "Shift-level production performance with target attainment by machine.",
            },
            {
                id: "1.3",
                name: "Machine-wise Production Report",
                template: "heatmap",
                filters: ["daterange", "devices", "part"],
                desc: "Machine × day production heatmap for fast comparative scanning.",
            },
            {
                id: "1.5",
                name: "Production vs Target Report",
                template: "bullet",
                filters: ["daterange", "devices", "part"],
                desc: "Actual-versus-target variance view with explicit target markers.",
            },
        ],
    },
    {
        key: "downtime",
        label: "Downtime & Availability",
        color: "#e2503f",
        reports: [
            {
                id: "2.1",
                name: "Downtime Report",
                template: "timeline",
                filters: ["daterange", "devices"],
                desc: "Chronological downtime event log — what stopped, when, for how long. Tag a reason on any event to feed the Reason Pareto.",
            },
            {
                id: "2.2",
                name: "Downtime Reason Report",
                template: "pareto",
                filters: ["daterange", "devices"],
                desc: "Pareto analysis of tagged downtime reasons with cumulative contribution.",
            },
        ],
    },
    {
        key: "maintenance",
        label: "Maintenance",
        color: "#f2a93c",
        reports: [
            {
                id: "5.1",
                name: "Maintenance Summary Report",
                template: "maintSummary",
                filters: ["devices"],
                desc: "Maintenance schedule health: upcoming, in-progress and past windows per machine.",
            },
            {
                id: "5.2",
                name: "Planned Maintenance Report",
                template: "checklist",
                filters: ["devices"],
                desc: "Upcoming planned-maintenance checklist with windows and machines.",
            },
        ],
    },
    {
        key: "energy",
        label: "Energy & Utilities",
        color: "#17a2a0",
        reports: [
            {
                id: "6.1",
                name: "Energy Consumption Report",
                template: "trend",
                filters: ["daterange", "devices"],
                desc: "Raw power-index trend from the analog input (uncalibrated — no kWh until meters are calibrated).",
            },
            {
                id: "6.2",
                name: "Machine-wise Energy Report",
                template: "energyHeatmap",
                filters: ["daterange", "devices"],
                desc: "Machine × day power-index matrix for cross-machine comparison (uncalibrated).",
            },
        ],
    },
];

export const TEMPLATE_LABELS = {
    productionKpi: "KPI + Target Bars",
    shiftKpi: "Shift KPI + Target Bars",
    heatmap: "Heatmap Matrix",
    bullet: "Variance / Bullet Bars",
    timeline: "Timeline / Event Log",
    pareto: "Pareto Analysis",
    maintSummary: "Schedule Summary",
    checklist: "Maintenance Checklist",
    trend: "Trend Line",
    energyHeatmap: "Heatmap Matrix",
};

export const DEVICE_COLORS = ["#2f6fed", "#e2503f", "#17a2a0", "#8b5cf6", "#f2a93c", "#2fb380"];
